/**
 * Customization
 * Added background image
 */
import React from 'react';
import config from '@plone/volto/registry';

const Background = ({ block }) => {
  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <div className="searchSections-background">
      {block?.backgroundImage?.length > 0 && (
        <picture className="volto-image">
          <Image
            item={block.backgroundImage[0]}
            imageField={block.backgroundImage[0].image_field}
            key={block.backgroundImage[0]['@id']}
            alt=""
            aria-hidden="true"
            loading="lazy"
            role="presentation"
            responsive={true}
          />
        </picture>
      )}
    </div>
  );
};

export default Background;
